import React from "react";
import { createPortal } from "react-dom";

/** Модальное окно поверх всего приложения */
export function AdminModal({
  open,
  title,
  onClose,
  children,
  footer,
  wide,
}) {
  if (!open || typeof document === "undefined") return null;

  return createPortal(
    <div
      className="admin-overlay"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className={`admin-modal surface ${wide ? "admin-modal--wide" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="admin-modal-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__head">
          <h2 id="admin-modal-title" className="admin-modal__title">
            {title}
          </h2>
          <button
            type="button"
            className="admin-modal__close"
            onClick={onClose}
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>
        <div className="admin-modal__body">{children}</div>
        {footer ? <div className="admin-modal__foot">{footer}</div> : null}
      </div>
    </div>,
    document.body
  );
}

/** Выезжающая панель справа (детали заказа) */
export function AdminDrawer({ open, title, onClose, children }) {
  if (!open || typeof document === "undefined") return null;

  return createPortal(
    <>
      <div
        className="admin-overlay admin-overlay--drawer"
        role="presentation"
        onMouseDown={onClose}
      />
      <div className="admin-drawer surface" role="dialog" aria-modal="true">
        <div className="admin-drawer__head">
          <h2 className="admin-drawer__title">{title}</h2>
          <button
            type="button"
            className="admin-modal__close"
            onClick={onClose}
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>
        <div className="admin-drawer__body">{children}</div>
      </div>
    </>,
    document.body
  );
}

/** Временное сообщение об успехе / ошибке */
export function AdminFlash({ type, message, onClose }) {
  if (!message) return null;
  return (
    <div className={`admin-flash admin-flash--${type}`} role="alert">
      <span>{message}</span>
      <button type="button" className="admin-flash__dismiss" onClick={onClose}>
        ×
      </button>
    </div>
  );
}
